import NotificationsModule from './notifications.module'

export default NotificationsModule
